import EditCompanyPage from './EditCompany';
import { createEditCompanyHandle } from './handle';

export default {
  Component: EditCompanyPage,
  createHandle: createEditCompanyHandle
};
